import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { MediaType, MetaProps, RatingSummary, RecipeMetaSectionProps } from '@repo/ui/src/types';
import RatingStars from '@repo/ui/src/components/RatingStars';
import Image from '@repo/ui/src/components/Image';
import { Anchor } from '@repo/ui/src/components/Anchor';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';

export interface RecipeCardSimpleProps {
  _meta: MetaProps;
  recipeMetaSection: RecipeMetaSectionProps;
  assets: Array<MediaType>;
  darkMode?: boolean;
  recipeMigrationSection: any;
  ratingSummary: RatingSummary;
}

const RecipeCard = ({ recipeMetaSection, assets, _meta, darkMode, ratingSummary }: RecipeCardSimpleProps) => {
  const imageUrl = buildImageSrc(assets?.length ? assets[0] : null, 700, 2, 1);
  const link = {
    displayName: 'View the Recipe',
    link: _meta?.deliveryKey,
  };

  if (!recipeMetaSection) return null;

  return (
    <div className="grid grid-rows-[auto_3fr_auto] h-full bg-white border border-warm-300">
      <Anchor
        link={link.link}
        className="absolute top-0 left-0 w-full h-full z-10"
        tabIndex={-1}
        label={recipeMetaSection?.title}
      />
      <div className="relative h-[200px]">
        <Image
          src={imageUrl}
          alt={recipeMetaSection?.title}
          layout="fill"
          height={250}
          width={250}
          objectFit="cover"
        />
      </div>

      <div data-testid="rc-header" className="flex flex-col h-full pt-6 px-6">
        <h4 className="tra-text-web-heading-6 text-left">{recipeMetaSection?.title}</h4>
        {ratingSummary?.average && (
          <div className="pt-2">
            <RatingStars value={ratingSummary?.average} />
          </div>
        )}
      </div>
      <div className="px-6 pt-12 pb-8">
        <Button
          {...link}
          as={Anchor}
          variant={ButtonVariant.knife}
          dark={!!darkMode}
          className="z-20"
          size="small"
        >
          {link?.displayName}
        </Button>
      </div>
    </div>
  );
};

export default RecipeCard;
